import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { GameLogic } from '../../../Logic/GameLogic';
import { ButtonController } from '../../../Common/ButtonController';
import { GameModel } from '../../../Models/GameModel';
import { RescueLogic } from '../../../Logic/MiniGames/RescueLogic';
import { SliderController } from './SliderController';
import { RescueButtonController } from './RescueButtonController';

export interface IRescueGameUIControllerOptions {
    onComplete: () => void;
}

export class RescueGameUIController extends AnimationBaseController {
    public $model: GameModel;

    public constructor(@Inject private _options: IRescueGameUIControllerOptions,
                       @Inject private _rescueLogic: RescueLogic,
                       @Inject private _gameLogic: GameLogic,
    ) {
        super('RescueGameUIController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.RESCUE_GAME_SCREEN_JSON,
            libraryName: 'mini_game_rescue',
            childControllers: {
                buttonSpeedUp: {
                    instanceName: 'arrow_up',
                    controller: RescueButtonController,
                    options: {
                        mouseDown: ()=>{
                            this._rescueLogic.setForward(true);
                        },
                        mouseUp: ()=>{
                            this._rescueLogic.setForward(false);
                        }
                    },
                },
                // buttonSpeedDown: {
                //     instanceName: 'arrow_down',
                //     controller: ButtonController,
                //     options: {
                //         onClick: () => {
                //             this._rescueLogic.reducingPosition();
                //         },
                //     },
                // },
                slider: {
                    instanceName: 'slider.slider_cursor',
                    controller: SliderController,
                    model: this.$model,
                    options: {
                        onClick: () => {
                            // this._rescueLogic.reducingPosition();
                        },
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        // this.$childControllers.get('buttonSpeedDown').visible = false;
    }

    protected onResize(width: number, height: number, scale: number) {
        const scaleValue = Math.min(
            width / scale / 1200,
            height / scale / 1200,
        );
        const controlPos = width/scale/this.parentContainer.scale.x*0.38;
        this.container.children[0].x = controlPos;
        this.container.children[1].x = controlPos;
        // this.container.children[0].scale.x = 1/scaleValue;
        // this.container.children[0].scale.y = 1/scaleValue;
        //@ts-ignore
        this.container.children[1].scale.x = 1.35/ this.container.parent.scale.x;
        this.container.children[1].scale.y = this.container.children[1].scale.x;
        
        // this.container.children[2].x = controlPos;

        this.container.y = 0;
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }
}
